import React, { useState } from "react";
import AgeFilterSection from "./AgeFilterSection";
import { AgeRange } from "./useAgeRanges";

interface FilterSidebarProps {
  onFilterChange: (filters: Record<string, any>) => void;
}

const FilterSidebar: React.FC<FilterSidebarProps> = ({ onFilterChange }) => {
  const [tempFilters, setTempFilters] = useState<Record<string, any>>({});

  const handleToggle = (key: string) => {
    const updated = { ...tempFilters };

    if (updated[key]) {
      delete updated[key];
      if (key === "age") {
        delete updated.ageRanges; // Καθαρισμός αν ξε-τσεκαριστεί η ηλικία
      }
    } else {
      updated[key] = true;
    }

    setTempFilters(updated);
  };

  const handleAgeRangesChange = (ranges: AgeRange[]) => {
    setTempFilters((prev) => ({
      ...prev,
      ageRanges: ranges,
    }));
  };

  const handleApplyFilters = () => {
    onFilterChange(tempFilters);
  };

  const handleResetFilters = () => {
    setTempFilters({});
    onFilterChange({});
  };

  const categories = [
    { key: "gender", label: "Φύλο" },
    { key: "surgery", label: "Χειρουργεία" },
    { key: "medication", label: "Φάρμακα" },
    { key: "rehab", label: "Αποκατάσταση" },
    { key: "implants", label: "Εμφυτεύματα" },
    { key: "allergies", label: "Αλλεργίες" },
  ];

  return (
    <div className="w-64 bg-gray-50 border-r border-gray-200 p-4 flex flex-col gap-6 select-none">
      <h3 className="font-semibold text-gray-700 text-sm border-b pb-2">
        Φίλτρα Αναζήτησης
      </h3>

      <div className="flex flex-col gap-2">
        <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
          Κατηγορίες
        </label>
        <div className="flex flex-col gap-2">
          {categories.map((cat) => {
            const isSelected = !!tempFilters[cat.key];
            return (
              <button
                key={cat.key}
                type="button"
                onClick={() => handleToggle(cat.key)}
                className={`w-full text-left px-3 py-2 text-sm font-medium rounded border transition-colors ${
                  isSelected
                    ? "bg-primary text-white border-primary shadow-sm"
                    : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
                }`}
              >
                {cat.label}
              </button>
            );
          })}

          {/* --- ΝΕΟ FILTER SECTION: ΗΛΙΚΙΑ --- */}
          <AgeFilterSection
            isSelected={!!tempFilters["age"]}
            onToggleSelect={() => handleToggle("age")}
            onRangesChange={handleAgeRangesChange}
          />
        </div>
      </div>

      <div className="flex flex-col gap-2 mt-auto pt-4 border-t border-gray-200">
        <button
          type="button"
          onClick={handleApplyFilters}
          className="w-full bg-primary hover:opacity-90 text-white text-sm font-medium py-2 px-4 rounded transition-colors shadow-sm cursor-pointer"
        >
          Εφαρμογή Φίλτρων
        </button>

        <button
          type="button"
          onClick={handleResetFilters}
          className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-medium py-2 px-4 rounded transition-colors cursor-pointer"
        >
          Καθαρισμός
        </button>
      </div>
    </div>
  );
};

export default FilterSidebar;